import { IpaginatedToppagesaboutus, IToppagesaboutusItem } from '../models'

export enum ToppagesaboutusActionTypes {
  SEARCH_TOPPAGESABOUTUS = 'toppagesaboutus/search',
  SEARCHING_TOPPAGESABOUTUS = 'toppagesaboutus/searching',
  FOUND_TOPPAGESABOUTUS = 'toppagesaboutus/found',
  SEARCHING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/searching_failed',

  LOAD_TOPPAGESABOUTUS = 'toppagesaboutus/load',
  LOADING_TOPPAGESABOUTUS = 'toppagesaboutus/loading',
  LOADED_TOPPAGESABOUTUS = 'toppagesaboutus/loaded',
  LOADING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/loading_failed',

  ADD_TOPPAGESABOUTUS = 'toppagesaboutus/add',
  ADDING_TOPPAGESABOUTUS = 'toppagesaboutus/adding',
  ADDED_TOPPAGESABOUTUS = 'toppagesaboutus/added',
  ADDING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/adding_failed',

  REMOVE_TOPPAGEABOUTUS = 'toppagesaboutus/remove',
  REMOVING_TOPPAGEABOUTUS = 'toppagesaboutus/removing',
  REMOVED_TOPPAGEABOUTUS = 'toppagesaboutus/removed',
  REMOVING_TOPPAGEABOUTUS_FAILED = 'toppagesaboutus/removing_failed',

  SOFT_REMOVE_TOPPAGESABOUTUS = 'toppagesaboutus/soft_remove',
  SOFT_REMOVING_TOPPAGESABOUTUS = 'toppagesaboutus/soft_removing',
  SOFT_REMOVED_TOPPAGESABOUTUS = 'toppagesaboutus/soft_removed',
  SOFT_REMOVING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/soft_removing_failed',

  EDIT_TOPPAGESABOUTUS = 'toppagesaboutus/edit',
  EDITING_TOPPAGESABOUTUS = 'toppagesaboutus/editing',
  EDITED_TOPPAGESABOUTUS = 'toppagesaboutus/edited',
  EDITING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/editing_failed',

  VIEW_TOPPAGESABOUTUS = 'toppagesaboutus/view',
  VIEWING_TOPPAGESABOUTUS = 'toppagesaboutus/viewing',
  VIEWED_TOPPAGESABOUTUS = 'toppagesaboutus/viewed',
  VIEWING_TOPPAGESABOUTUS_FAILED = 'toppagesaboutus/viewing_failed',
}

export function searchToppagesaboutus(searchOptions: TSearchOptions | string, keep?: boolean): ISearchToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.SEARCH_TOPPAGESABOUTUS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingToppagesaboutus(): ISearchingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS,
  }
}

export function foundToppagesaboutus(toppagesaboutus: IpaginatedToppagesaboutus, keep?: boolean): IFoundToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.FOUND_TOPPAGESABOUTUS,
    keep: keep,
    payload: {
      toppagesaboutus,
    },
  }
}

export function searchingToppagesaboutusFailed(): ISearchingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS_FAILED,
  }
}

export function loadToppagesaboutus(loadOptions: TSearchOptions): ILoadToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.LOAD_TOPPAGESABOUTUS,
    loadOptions: loadOptions,
  }
}

export function loadingToppagesaboutus(): ILoadingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS,
  }
}

export function loadedToppagesaboutus(toppagesaboutus: IpaginatedToppagesaboutus): ILoadedToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.LOADED_TOPPAGESABOUTUS,
    payload: {
      toppagesaboutus,
    },
  }
}

export function loadingToppagesaboutusFailed(): ILoadingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS_FAILED,
  }
}

export function addToppagesaboutus(toppageaboutus: IToppagesaboutusItem): IAddToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.ADD_TOPPAGESABOUTUS,
    payload: toppageaboutus,
  }
}

export function addingToppagesaboutus(): IAddingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS,
  }
}

export function addedToppagesaboutus(toppagesaboutus: IpaginatedToppagesaboutus): IAddedToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.ADDED_TOPPAGESABOUTUS,
    payload: {
      toppagesaboutus,
    },
  }
}

export function addingToppagesaboutusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IAddingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeToppageaboutus(toppageaboutus: IToppagesaboutusItem): IRemoveToppageaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.REMOVE_TOPPAGEABOUTUS,
    payload: toppageaboutus,
  }
}

export function removingToppageaboutus(): IRemovingToppageaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.REMOVING_TOPPAGEABOUTUS,
  }
}

export function removedToppageaboutus(): IRemovedToppageaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.REMOVED_TOPPAGEABOUTUS,
  }
}

export function removingToppageaboutusFailed(): IRemovingToppageaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.REMOVING_TOPPAGEABOUTUS_FAILED,
  }
}

export function softRemoveToppagesaboutus(toppageaboutus: IToppagesaboutusItem): ISoftRemoveToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.SOFT_REMOVE_TOPPAGESABOUTUS,
    payload: toppageaboutus,
  }
}

export function softRemovingToppagesaboutus(): ISoftRemovingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS,
  }
}

export function softRemovedToppagesaboutus(toppageaboutus: IToppagesaboutusItem): ISoftRemovedToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.SOFT_REMOVED_TOPPAGESABOUTUS,
    payload: toppageaboutus,
  }
}

export function softRemovingToppagesaboutusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editToppagesaboutus(toppageaboutus: IToppagesaboutusItem): IEditToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.EDIT_TOPPAGESABOUTUS,
    payload: toppageaboutus,
  }
}

export function editingToppagesaboutus(): IEditingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS,
  }
}

export function editedToppagesaboutus(toppagesaboutus: IToppagesaboutusItem): IEditedToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.EDITED_TOPPAGESABOUTUS,
    payload: toppagesaboutus,
  }
}

export function editingToppagesaboutusFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewToppagesaboutus(toppageaboutus: IToppagesaboutusItem): IViewToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.VIEW_TOPPAGESABOUTUS,
    payload: toppageaboutus,
  }
}

export function viewingToppagesaboutus(): IViewingToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.VIEWING_TOPPAGESABOUTUS,
  }
}

export function viewedToppagesaboutus(toppagesaboutus: IToppagesaboutusItem): IViewedToppagesaboutusAction {
  return {
    type: ToppagesaboutusActionTypes.VIEWED_TOPPAGESABOUTUS,
    payload: toppagesaboutus,
  }
}

export function viewingToppagesaboutusFailed(): IViewingToppagesaboutusFailedAction {
  return {
    type: ToppagesaboutusActionTypes.VIEWING_TOPPAGESABOUTUS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.SEARCH_TOPPAGESABOUTUS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS
}

export interface IFoundToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.FOUND_TOPPAGESABOUTUS
  keep?: boolean
  payload: {
    toppagesaboutus: IpaginatedToppagesaboutus
  }
}

export interface ISearchingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.SEARCHING_TOPPAGESABOUTUS_FAILED
}

export interface ILoadToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.LOAD_TOPPAGESABOUTUS
  loadOptions: TSearchOptions
}

export interface ILoadingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS
}

export interface ILoadedToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.LOADED_TOPPAGESABOUTUS
  payload: {
    toppagesaboutus: IpaginatedToppagesaboutus
  }
}

export interface ILoadingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.LOADING_TOPPAGESABOUTUS_FAILED
}

export interface IAddToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.ADD_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface IAddingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS
}

export interface IAddedToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.ADDED_TOPPAGESABOUTUS
  payload: {
    toppagesaboutus: IpaginatedToppagesaboutus
  }
}

export interface IAddingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.ADDING_TOPPAGESABOUTUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveToppageaboutusAction {
  type: ToppagesaboutusActionTypes.REMOVE_TOPPAGEABOUTUS
  payload: IToppagesaboutusItem
}

export interface IRemovingToppageaboutusAction {
  type: ToppagesaboutusActionTypes.REMOVING_TOPPAGEABOUTUS
}

export interface IRemovedToppageaboutusAction {
  type: ToppagesaboutusActionTypes.REMOVED_TOPPAGEABOUTUS
}

export interface IRemovingToppageaboutusFailedAction {
  type: ToppagesaboutusActionTypes.REMOVING_TOPPAGEABOUTUS_FAILED
}

export interface ISoftRemoveToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.SOFT_REMOVE_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface ISoftRemovingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS
}

export interface ISoftRemovedToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.SOFT_REMOVED_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface ISoftRemovingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.SOFT_REMOVING_TOPPAGESABOUTUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.EDIT_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface IEditingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS
}

export interface IEditedToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.EDITED_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface IEditingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.EDITING_TOPPAGESABOUTUS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.VIEW_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface IViewingToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.VIEWING_TOPPAGESABOUTUS
}

export interface IViewedToppagesaboutusAction {
  type: ToppagesaboutusActionTypes.VIEWED_TOPPAGESABOUTUS
  payload: IToppagesaboutusItem
}

export interface IViewingToppagesaboutusFailedAction {
  type: ToppagesaboutusActionTypes.VIEWING_TOPPAGESABOUTUS_FAILED
}

export type ToppagesaboutusAction =
  | ISearchToppagesaboutusAction
  | ISearchingToppagesaboutusAction
  | IFoundToppagesaboutusAction
  | ISearchingToppagesaboutusFailedAction
  | ILoadToppagesaboutusAction
  | ILoadingToppagesaboutusAction
  | ILoadedToppagesaboutusAction
  | ILoadingToppagesaboutusFailedAction
  | IAddToppagesaboutusAction
  | IAddingToppagesaboutusAction
  | IAddedToppagesaboutusAction
  | IAddingToppagesaboutusFailedAction
  | IRemoveToppageaboutusAction
  | IRemovingToppageaboutusAction
  | IRemovedToppageaboutusAction
  | IRemovingToppageaboutusFailedAction
  | ISoftRemoveToppagesaboutusAction
  | ISoftRemovingToppagesaboutusAction
  | ISoftRemovedToppagesaboutusAction
  | ISoftRemovingToppagesaboutusFailedAction
  | IEditToppagesaboutusAction
  | IEditingToppagesaboutusAction
  | IEditedToppagesaboutusAction
  | IEditingToppagesaboutusFailedAction
  | IViewToppagesaboutusAction
  | IViewingToppagesaboutusAction
  | IViewedToppagesaboutusAction
  | IViewingToppagesaboutusFailedAction
